import {Component, OnInit} from "@angular/core";
import {DOCUMENT_TYPES, VALUE_TYPE} from "../../enums/enums";
import {SPELL_TYPES_LIST} from "../../enums/e-spells";
import {BusService} from "../../services/bus.service";
import {paramsHelper} from "../../helpers/params-helper";
import {UI_TEXTS} from "../../enums/e-texts";
import {IDocument} from "../../interfaces/document.definition";
import {localeUtils} from "../../helpers/locale-utils";



@Component({
  templateUrl: "./spells-page.component.html"
})


export class SpellPageComponent implements OnInit {
  UI_TEXTS = UI_TEXTS;
  pageParams = paramsHelper.page()
    .setTitle("Заклинания");

  collectionParams = paramsHelper.collection()
    .setObjectType(DOCUMENT_TYPES.SPELL)
    .setDefaultListLabels()
    .setItemLabelQuery(`locales.${localeUtils.getLocale()}[key=name].value.0`)
    .setSearchParams(paramsHelper.search()
      .addNumberParam("id")
      .addStringParam("name"));

  SPELL_TYPES_LIST = SPELL_TYPES_LIST;
  VALUE_TYPE = VALUE_TYPE;
  document: IDocument;


  constructor(private busService: BusService) {
  }


  ngOnInit() {
    this.busService.onDocumentUpdated
      .subscribe(
        e => this.document = e.document);
  }
}



// WEBPACK FOOTER //
// /opt/app/develop/src/app/pages/spells/spells-page.component.ts